import loadable from '@loadable/component';

import './MessageCenter.css';

export default loadable(() => {
  return import('./MessageCenter.jsx');
});
